import React, { FC, memo, useContext, useEffect, useRef, useState } from 'react'

import { Button } from '@Components/Button'
import { useSavedCheckoutLocalData } from '@Domains/Checkout/Hooks/useSavedCheckoutLocalData'
import { PaymentProviderBusContext, PaymentProviders } from '@Domains/Checkout/Steps/Payment/PaymentProviderFactory/PaymentProviderBus'
import {
  ByJunoForm,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Default/Components/ByJuno/ByJunoForm'
import {
  useByJunoCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Default/hooks/useByJunoCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'
import { useTranslation } from '@Globals/Translations'
import { CheckoutV2FinalizeCartResult } from '@Pages/onestepcheckout'

import styles from './ByJuno.module.scss'

enum ButtonState {
  Submit = 'Submit',
  Idle = 'Idle',
}

export type ByJunoFormData = {
  day: string
  gender: string
  invoiceType: string
  month: string
  year: string
}

export const ByJunoInfoComponent: FC<CheckoutPaymentComponentProps> = memo(({ option, submitPayment }) => {
  const { handleByJunoPaymentSubmitResponse } = useByJunoCheckoutResponse()
  const { busData, setBusData } = useContext(PaymentProviderBusContext)(PaymentProviders.ByJuno)
  const { checkoutLocal } = useSavedCheckoutLocalData()

  const [formData, setFormData] = useState<ByJunoFormData>({
    gender: checkoutLocal?.byJunoData?.gender || '',
    day: checkoutLocal?.byJunoData?.day || '',
    month: checkoutLocal?.byJunoData?.month || '',
    year: checkoutLocal?.byJunoData?.year || '',
    invoiceType: checkoutLocal?.byJunoData?.invoiceType || 'email',
  })

  const [formValid, setFormValid] = useState(false)

  const { t } = useTranslation()

  const ref = useRef<HTMLFormElement | null>(null)

  useEffect(() => {
    if (busData === ButtonState.Submit) {
      ref.current?.requestSubmit()

      setBusData(ButtonState.Idle)

      if (formValid) {
        submitPayment(
          {
            type: 'by-juno',
            isValid: formValid,
            formData: {
              ...formData,
              hasPassedValidation: formValid,
            },
          },
          (response: CheckoutV2FinalizeCartResult) => handleByJunoPaymentSubmitResponse(option.type, response),
        )
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busData, setBusData])

  return (
    <div className={styles.byJunoInfo}>
      <p className={styles.payInfoHeader}>{t('checkout:COF_FILL_OUT_PAYMENT_INFO')}</p>

      <ByJunoForm
        formData={formData}
        formValid={formValid}
        option={option}
        ref={ref}
        setFormData={setFormData}
        setFormValid={setFormValid}
      />
    </div>
  )
})

export const ByJunoButton: FC<CheckoutPaymentComponentProps> = memo(() => {
  const { t } = useTranslation()
  const { setBusData } = useContext(PaymentProviderBusContext)(PaymentProviders.ByJuno)

  return (
    <div className={styles.byJunoWrapper}>
      <Button
        className={styles.redirectButton}
        onClick={() => {
          setBusData(ButtonState.Submit)
        }}
      >
        {t('checkout:COF_GO_TO_SECURE_PAYMENT')}
      </Button>
    </div>
  )
})
